import { SvgIconProps, SvgIcon } from '@mui/material'

export default function Twitch (props: SvgIconProps) {
  return <SvgIcon {...props}>
    <path d="M11.64 5.93h1.43v4.28h-1.43m3.93-4.28H17v4.28h-1.43M7 2L3.43 5.57v12.86h4.28V22l3.58-3.57h2.85L20.57 12V2m-1.43 9.29l-2.85 2.85h-2.86l-2.5 2.5v-2.5H7.71V3.43h11.43Z"/>
  </SvgIcon>
}
